export default {
  getFormSchema(state) {
    return state.formSchema;
  },
};
